export const GET_PURCHASEORDER_REQUEST = "GET_PURCHASEORDER_REQUEST";
export const GET_PURCHASEORDER_SUCCESS = "GET_PURCHASEORDER_SUCCESS";
export const GET_PURCHASEORDER_PAGINATION = "GET_PURCHASEORDER_PAGINATION";

export const GET_PURCHASEORDER_FAIL = "GET_PURCHASEORDER_FAIL";

export const CREATE_PURCHASEORDER_REQUEST = "CREATE_PURCHASEORDER_REQUEST";
export const CREATE_PURCHASEORDER_SUCCESS = "CREATE_PURCHASEORDER_SUCCESS";
export const CREATE_PURCHASEORDER_FAIL = "CREATE_PURCHASEORDER_FAIL";

export const UPDATE_PURCHASEORDER_REQUEST = "UPDATE_PURCHASEORDER_REQUEST";
export const UPDATE_PURCHASEORDER_SUCCESS = "UPDATE_PURCHASEORDER_SUCCESS";
export const UPDATE_PURCHASEORDER_FAIL = "UPDATE_PURCHASEORDER_FAIL";

export const DELETE_PURCHASEORDER_REQUEST = "DELETE_PURCHASEORDER_REQUEST";
export const DELETE_PURCHASEORDER_SUCCESS = "DELETE_PURCHASEORDER_SUCCESS";
export const DELETE_PURCHASEORDER_FAIL = "DELETE_PURCHASEORDER_FAIL";

export const GET_VENDORPURCHASEORDER_REQUEST = "GET_VENDORPURCHASEORDER_REQUEST";
export const GET_VENDORPURCHASEORDER_SUCCESS = "GET_VENDORPURCHASEORDER_SUCCESS";
export const GET_VENDORPURCHASEORDER_FAIL = "GET_VENDORPURCHASEORDER_FAIL";

export const GET_SELECTEDPO_REQUEST = "GET_SELECTEDPO_REQUEST";
export const GET_SELECTEDPO_SUCCESS = "GET_SELECTEDPO_SUCCESS";
export const GET_SELECTEDPO_FAIL = "GET_SELECTEDPO_FAIL";
export const CLEAR_SELECTED_PO = "CLEAR_SELECTED_PO";
export const REMOVE_SELECTED_PO = "REMOVE_SELECTED_PO"

export const GENERATE_PDF_REQUEST = "GENERATE_PDF_REQUEST";
export const GENERATE_PDF_SUCCESS = "GENERATE_PDF_SUCCESS";
export const GENERATE_PDF_FAIL = "GENERATE_PDF_FAIL";

export const ADD_SELECTED_INVOICE = "ADD_SELECTED_INVOICE";
export const REMOVE_SELECTED_INVOICE = "REMOVE_SELECTED_INVOICE";